import type { FC } from 'react';
import clsx from 'clsx';

import { useCurrentUserStore } from 'store/currentUser';
import { useSizeStore } from 'store/size';

import User from 'components/Pages/Call/User';

import { useAllUserList } from 'hooks/useAllUserList';

import Description from './Description';
import Main from './Main';
import SizeControl from './SizeControl';
import styles from './styles.module.scss';

const Screen: FC = () => {
    const { isFull } = useSizeStore();
    const { screenShareUser } = useAllUserList();
    const showScreenShareUser = !!(isFull && screenShareUser);
    const { currentUser } = useCurrentUserStore();

    return (
        <div className={clsx(styles.wrapper, { [styles.wrapperIsFull]: isFull })}>
            <div className={styles.top}>
                <SizeControl />
                {showScreenShareUser && (
                    <User {...screenShareUser} isCurrentUser={currentUser?.id === screenShareUser.id} renderVideo className={styles.shareUser} />
                )}
            </div>
            <Main />
            <Description />
        </div>
    );
};

export default Screen;
